module.exports = __webpack_public_path__ + "img/home.bec135e4.svg";